//TODO : Refactor after ai
/**
 * Regelwerk aus Weg A für die Datenansicht: welche Action eine Rolle im
 * aktuellen Zustand ausführen darf, und was ein Zustandswechsel auslöst.
 * Logik identisch mit pages/viacid/aktionen.ts auf ba-mode – nur ohne Beyond UI.
 */

import { useDatenStore } from "@app/store";
import {
  pruefeAusfuehrung,
  transportBeauftragen,
  zahlungseingang,
  type Aktion,
  type Datensatz,
  type ObjektKlasse,
} from "@shared/demo-data/viacid";

export type Bedienung = "direkt" | "formular" | "beziehung";

export function bedienungVon(aktion: Aktion): Bedienung {
  if (aktion.operation === "Ändern") return "formular";
  if (aktion.operation === "Aufbauen") return "beziehung";
  return "direkt";
}

export function useStatusAktion() {
  const bestand = useDatenStore((s) => s.bestand);
  const anwenden = useDatenStore((s) => s.anwenden);
  const aendern = useDatenStore((s) => s.aendern);
  const melden = useDatenStore((s) => s.melden);

  return (klasse: ObjektKlasse, satz: Datensatz, aktion: Aktion) => {
    if (aktion.name === "Zahlungseingang übernehmen")
      return anwenden(zahlungseingang(bestand, satz.id));
    if (aktion.name === "Transport beauftragen")
      return anwenden(transportBeauftragen(bestand, satz.id));
    if (aktion.name === "Ausführung freigeben") {
      const problem = pruefeAusfuehrung(bestand, satz.id);
      if (problem) return melden(problem, true);
    }
    if (!aktion.ziel)
      return melden(`${aktion.name}: im Prototyp ohne Wirkung.`);
    const zusatz: Record<string, string> = {};
    const zeit = new Date().toISOString().slice(0, 16);
    const hat = (key: string) => klasse.felder.some((f) => f.key === key);
    if (hat("versendetAm") && aktion.ziel === "Versendet")
      zusatz.versendetAm = zeit;
    if (
      hat("entschiedenAm") &&
      ["Angenommen", "Abgelehnt", "Gewonnen", "Verloren"].includes(aktion.ziel)
    )
      zusatz.entschiedenAm = zeit;
    if (hat("freigegebenAm") && aktion.ziel === "Freigegeben")
      zusatz.freigegebenAm = zeit;
    if (hat("bewertetAm") && aktion.ziel === "Bewertet")
      zusatz.bewertetAm = zeit;
    if (klasse.slug === "auftrag" && aktion.ziel === "Abrechnungsbereit")
      zusatz.abrechnungsbereitSeit = zeit;
    if (klasse.slug === "rechnung" && aktion.ziel === "Gemahnt") {
      const stufe = Number(satz.werte.mahnstufe ?? 0) + 1;
      aendern(
        {
          slug: klasse.slug,
          id: satz.id,
          status: "Gemahnt",
          werte: { mahnstufe: stufe, letzteMahnungAm: zeit.slice(0, 10) },
        },
        `${aktion.name}: Mahnstufe ${stufe}.`
      );
      return;
    }
    aendern(
      { slug: klasse.slug, id: satz.id, status: aktion.ziel, werte: zusatz },
      `${aktion.name} – jetzt „${aktion.ziel}“.`
    );
  };
}
